
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import { fetchJobUnlock, fetchRemove3rdStop, fetchSetJobLock } from '@/helpers/fetchers';
import { JobComplianceData } from '@/models/JobComplianceTypes';
import { mapState } from 'vuex';
import { User } from '@/models/main';
import { JobLockError, ValidationAPIError } from '@/helpers/throwables';
import { notifyNetworkError } from '@/helpers/notifiers';

@Component({
  components: {
    Icon,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class Remove3rdStop extends Vue {
  @Prop({ type: Object, required: false, default: false }) public formData: JobComplianceData;

  private user!: User;
  public loading = false;

  public async remove3rdStop() {
    if (this.formData.stops[2]._isTmp) {
      return this.$emit('removeTmp3rdStop');
    }
    this.loading = true;

    await fetchSetJobLock(this.formData.rockhopper_id, this.formData.rockhopper_date)
      .then(async () => {
        await fetchRemove3rdStop(this.formData.rockhopper_id, this.formData.rockhopper_date, 3, {})
          .then(() => {
            this.$emit('fetchData');
          })
          .catch(err => {
            // In case of validation error, unlock the job
            if (err instanceof ValidationAPIError) {
              notifyNetworkError({ text: err.message });
            }
          })
          .finally(async () => {
            await fetchJobUnlock(this.formData.rockhopper_id, this.formData.rockhopper_date);
          });
      })
      .catch(err => {
        if (err instanceof JobLockError) {
          return;
        }
      });

    this.loading = false;
  }
}
